import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { logger } from './utils/logger';
import './index.css';

function bootstrap() {
  try {
    logger.info('Starting RepliCloud application');
    const el = document.getElementById('root');
    if (!el) throw new Error('Root container not found');
    const root = createRoot(el);
    root.render(<App />);
  } catch (err) {
    logger.fatal('Failed to bootstrap application', {
      error: err instanceof Error ? err.message : String(err)
    });
  }
}

bootstrap();
